import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { socialReturnOnInvestmentReportSelector } from '../../../../modules/selectors/socialReturnOnInvestment'

// Custom hook to determine visibility of SROI report sections and filters
// based on the data available in the report
export const useSroiReportVisibility = () => {
  const report = useSelector(socialReturnOnInvestmentReportSelector)

  return useMemo(() => {
    const regions = report?.regional_impact || []
    const categoricalImpact = report?.categorical_impact || []

    return {
      hasMultipleRegions: regions.length > 1,
      hasMultipleStakeholders: categoricalImpact.length > 1
    }
  }, [report])
}
